import {DecimalPipe} from '@angular/common';
import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiModulesService} from 'src/app/api-modules.service';
import {NgbdSortableHeader, SortEvent} from 'src/app/shared/directives/NgbdSortableHeader';
import {TableService} from 'src/app/shared/service/table.service';
import {LISTPAGEDB, ListPagesDB} from 'src/app/shared/tables/list-pages';

@Component({
    selector: 'app-list-page',
    templateUrl: './list-page.component.html',
    styleUrls: ['./list-page.component.scss'],
    providers: [TableService, DecimalPipe]
})
export class ListPageComponent implements OnInit {
    public selected = [];
    public tableItem$: Observable<ListPagesDB[]>;
    public searchText;
    public editID: any;
    visible: any = true;
    total$: Observable<number>;
    public username = [];
    page = 1;
    pageSize = 10;
    public sorting = {column : 'name', direction : 'asc'};
    data: any[] = [];
    filterParams: any = {};
    sortField: any = '';
    sortOrder: any = '';
    searchQuery: any = '';
    constructor(private apiModulesService: ApiModulesService, public service: TableService) {
        this.getChannelNames(this.sorting);
        this.tableItem$ = service.tableItem$;
        this.total$ = service.total$;
        this.service.setUserData(LISTPAGEDB);


    }

    @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

    onSort({column, direction}: SortEvent) {

        this.headers.forEach((header) => {
            if (header.sortable !== column) {
                header.direction = '';
            }
        });

        this.service.sortColumn = column;
        this.service.sortDirection = direction;
    }

    onSelect({selected}) {
        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
    }

    ngOnInit(): void {
        this.loadData();
    }

    loadData() {
        this.apiModulesService.getData('telegram/channel/list', this.filterParams, this.sortField, this.sortOrder, this.searchQuery)
            .subscribe((response: any) => {
                this.data = response;
            });
    }

    applyFilter() {
        this.loadData();
    }

    applySort() {
        this.loadData();
    }

    applySearch() {
        this.loadData();
    }
    public getChannelNames(sort) {
        this.apiModulesService.list('telegram/channel/lists', sort).subscribe((data) => {
            this.service.setUserData(data.data);
        });
    }

    public editChannels(id) {
        this.editID = id;
        this.visible = false;
    }

    childEmitted(data: any) {
        // console.log(data);
        this.visible = data;
        this.loadData();

    }
}
